import React, { useState, useEffect } from 'react'
import { CardAnswerModel } from '../../../../model/knowledge.model'
import {
    CardDescIcon,
    CardLinkIcon,
    CardThumbIcon,
    CardTitleIcon,
} from '../../../../conf/images'
import './CardAnswer.css'
import Upload from '../../../../components/Upload'
interface CardAnswerProps {
    finished?: boolean
    answer: string //CardAnswerModel
    completed?: boolean
    onConfirm?: (anwer: string) => any
    onCancel?: () => any
    onEdit?: () => void
}
const CardAnswer: React.FC<CardAnswerProps> = (props) => {
    let { finished, answer = '{}', onConfirm, onCancel, onEdit } = props
    let [answerPlainObj, setAnswerPlainObj] = useState<CardAnswerModel>({
        title: '',
        description: '',
        destination_url: '',
        cover_url: '',
    })
    const [editCompleted, setEditCompleted] = useState(false)
    useEffect(() => {
        if (answer) {
            setAnswerPlainObj(JSON.parse(answer))
        }
    }, [answer])
    useEffect(() => {
        setEditCompleted(
            !!(
                answerPlainObj.title &&
                answerPlainObj.cover_url &&
                answerPlainObj.description &&
                answerPlainObj.destination_url
            )
        )
    }, [answerPlainObj])
    const hanelCardTitleChange = (e: any) => {
        setAnswerPlainObj({
            ...answerPlainObj,
            title: e.target.value,
        })
    }
    const hanelCardDescChange = (e: any) => {
        setAnswerPlainObj({
            ...answerPlainObj,
            description: e.target.value,
        })
    }
    const hanelCardDestUrlChange = (e: any) => {
        setAnswerPlainObj({
            ...answerPlainObj,
            destination_url: e.target.value,
        })
    }
    if (finished) {
        return (
            <div
                className='card-answer card-answer--proto'
                onClick={() => {
                    onEdit && onEdit()
                }}
            >
                <p className='card-title'>{answerPlainObj.title}</p>
                <div className='card-bottom'>
                    <p className='card-desc'>{answerPlainObj.description}</p>
                    <img src={answerPlainObj.cover_url} alt='icon' />
                </div>
            </div>
        )
    }

    const handleConfirm = () => {
        if (!editCompleted) {
            console.log('请完善信息')
            return
        }
        console.log(answerPlainObj)
        onConfirm && onConfirm(JSON.stringify(answerPlainObj))
    }
    return (
        <div className='card-answer card-answer--editing'>
            <div className='card-input-item'>
                <img className='item-icon' src={CardTitleIcon} alt='icon' />
                <input
                    className='input'
                    type='text'
                    defaultValue={answerPlainObj.title}
                    placeholder='请输入卡片标题'
                    // value={answerPlainObj.title}
                    onChange={hanelCardTitleChange}
                />
            </div>
            <div className='card-input-item'>
                <img className='item-icon' src={CardDescIcon} alt='icon' />
                <input
                    className='input'
                    type='text'
                    defaultValue={answerPlainObj.description}
                    placeholder='请输入卡片描述'
                    // value={answerPlainObj.description}
                    onChange={hanelCardDescChange}
                />
            </div>
            <div className='card-input-item'>
                <img className='item-icon' src={CardLinkIcon} alt='icon' />
                <input
                    className='input'
                    type='text'
                    placeholder='请输入卡片链接'
                    defaultValue={answerPlainObj.destination_url}
                    onChange={hanelCardDestUrlChange}
                    // value={answerPlainObj.destination_url}
                />
            </div>
            <div className='card-image-wrapper'>
                <Upload
                    onResolve={(src) =>
                        setAnswerPlainObj({
                            ...answerPlainObj,
                            cover_url: src,
                        })
                    }
                >
                    <img
                        className='image-placeholder'
                        src={answerPlainObj.cover_url || CardThumbIcon}
                        alt='icon'
                    />
                </Upload>
                <span>2M以内</span>
            </div>
            <div className='card-bottom'>
                <button onClick={onCancel}>取消</button>
                <button
                    className={`confirm ${editCompleted ? 'active' : ''}`}
                    onClick={handleConfirm}
                >
                    完成
                </button>
            </div>
        </div>
    )
}

export default CardAnswer
